var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.text))]),_c('v-divider',{staticClass:"mb-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }